<template>
  <div>
    <!-- <div class="row justify-content-end">
      <div class="col-auto">
        <button class="btn btn-secondary" @click="
            $router.push({
              name: 'sales-items-edit',
              params: {
                reference: sale.reference,
              },
            })
          ">
          Modifier les articles
        </button>
      </div>
    </div> -->

    <br />
    <div class="row align-items-end">


      <div class="col-xl-3 ">
        <label for="">Client <span class="text-danger">*</span> </label>
        <vue-select :options="customers" v-model="sale.customer_reference" placeholder="Select an option"
          labelColumn="society" valueColumn="reference" />
      </div>

      <div class="col-auto">
        <label for="">Date <span class="text-danger">*</span></label>
        <input type="date" v-model="sale.date" class="form-control" />
      </div>
      <div class="col-auto">
        <label for="">Échéance </label>
        <input type="date" v-model="sale.deadline" class="form-control" />
      </div>
      <div class="col-auto">
        <label for="">Total </label>
        <input type="text" :disabled="!amounts_change ? true : false" v-model="sale.totalPriceTTC"
          class="form-control" />
      </div>

      <div class="col-auto">
        <label for="">Montant paye </label>
        <input type="text" :disabled="!amounts_change ? true : false" v-model="sale.amountPaid" class="form-control" />
      </div>

      <div class="col-auto">
        <label for="">M. reste </label>
        <input type="text" :disabled="!amounts_change ? true : false" v-model="sale.amountUnpaid"
          class="form-control" />
      </div>

      <div class="col-auto">
        <label for=""> </label>
        <input type="button" @click="
            amounts_change ? (amounts_change = false) : (amounts_change = true)
          " :value="amounts_change ? 'Désactiver' : 'Modifier les valeurs'" class="form-control bg-warning" />
      </div>

    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <label for=""> Remarque <span class="text-danger">*</span></label>
        <textarea type="date" v-model="sale.remark" class="form-control"></textarea>
      </div>
    </div>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-8">

      </div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(sale)">
          <i class="bi bi-check-square-fill"></i> Enregistrer les modifcations
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      customer_change: false,
      amounts_change: false,
    };
  },

  methods: {
    async save(data) {
      await this.$store.dispatch("sale/update", data);
    },
    async refresh() {
      this.$store.dispatch("sale/getAllItems");
    },
  }, 

  computed: {
    ...mapGetters("sale", {
      sale: "getSale",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("employee", {
      employees: "getAll",
    }),
  },

  mounted() {
    this.$store.dispatch("sale/show", this.$route.params.reference);
    this.$store.dispatch("customer/getAll");
    this.$store.dispatch("employee/getAll");
  },
};
</script>
